export enum MembershipOfferFeeType {
  'MATRÍCULA' = 'Taxa de Matrícula',
  'TAXA DE ADESÃO' = 'Taxa de Adesão',
  'TAXA DE CADASTRO' = 'Taxa de Cadastro',
}
